import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { CtaBlock } from '@/components/site/cta-block'
import { ImageSection } from '@/components/site/image-section'
import { AboutHero } from '@/components/landing/about/about-hero'
import { AboutStory } from '@/components/landing/about/about-story'
import { AboutProcess } from '@/components/landing/about/about-process'
import { AboutExperience } from '@/components/landing/about/about-experience'
import { AboutValues } from '@/components/landing/about/about-values'
import { AboutEducation } from '@/components/landing/about/about-education'
import { media } from '@/constants/media'

const About: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title="About"
                description="Zaki Hatta is a software engineer from Padang, Indonesia, with experience in Next.js platforms, WordPress sites, WebGIS and real-time mobile GIS."
            />

            <AboutHero />

            <ImageSection
                id='image'
                src={media.workspaceTyping}
                alt="A developer typing at a desk in front of a large monitor showing code"
                priority
                appear
                className='h-svh md:h-[630px] lg:h-svh'
            />

            <AboutStory />
            <AboutExperience />
            <AboutProcess />

            <ImageSection
                id='image-1'
                src={media.coastline}
                alt="Aerial view of a golden beach and turquoise waves on a tropical coast"
                className='aspect-[1.5]'
            />

            <AboutValues />
            <AboutEducation />
            <CtaBlock />
        </Layout>
    )
}

export default About
